import { FC } from "react";

import { FileItem } from "types";

import { FileDropArea } from "../droparea";

interface HookFormFileDropAreaProps {
    name: string;
    disabled?: boolean;
    maxUploadedFiles?: number;
    multiple?: boolean;
    onLoadFile?: (file: FileItem) => Promise<Partial<FileItem>>;
}

const HookFormFileDropArea: FC<HookFormFileDropAreaProps> = ({ name, disabled, maxUploadedFiles, multiple, onLoadFile }) => {
    return <FileDropArea name={name} disabled={disabled} maxUploadedFiles={maxUploadedFiles} multiple={multiple} onLoadFile={onLoadFile} />;
};

export default HookFormFileDropArea;
